(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('apiKeysQueryRequest', function () {

        function queryRequest() {
            this.order = '-createdAt';
            this.page = 1;
            this.limit = 5;
            this.search = {};
        }

        return queryRequest;
    });
})();
